import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js'
import download from 'downloadjs';
import Loader from './../shared/loader'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Pagination from './../shared/pagination'
import SimpleEncrypt from 'simple-encryptor'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel)
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import printpo from '../purchaseOrder/printpo'

export default {
	name: 'purchaseOrder',
	components: {
		//Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		download,
		Loader,
		BasicSelect,
		printpo
	},
	data: function() {
		return {
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			currentPage: 1,
			totalPage: 0,
			totalrows: 0,
			pageLimit: 10,
			// totalrows:0,
			// currentPage: 0,
			//modalShow used for close the active/inactive modal(default)
			isLoading: false,
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			statusclass: '',
			pono: "",
			ponoFlt: "",
			fromDateFlt: "",
			toDateFlt: "",
			newActionMsg: "",
			modelMessage: "",
			activeClass: 'btn-success',
			warningClass: 'btn-warning',
			purchasingManager: 0,
			isInwardUserForPO: false,
			merchant: '',
			listPurchaseOrderData: [],
			listMerchantData: [],
			csvFields: [],
			listClientData: [],
			listWarehouseData: [],
			listPurchaseOrderDatacsv: [],
			// pageCount: 0,
			// pageno: 0,
			// pageLimit: 10,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			formattedDate: '',
			item:{},
		   merchant:'',
		   listMerchantData1:[],
		   merchantList:[],
		   merchantname:'',
		   mid:'',
		   showSelectMerchant:false,
		   limitExeed: false,
		   resultCount: 0,
		   showeye:true,
		   filterData: {},
		   poStatus:''
		}
	},
	created: function() {
		// when a page loads,mounted() will be call
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.reportname = this.$t('purchaseOrder.purchaseOrderFile');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.key = '5VxHu9PR8QgPq7h67cUG0H34rYZQZmey';
		this.encryptor = SimpleEncrypt(this.key);
		this.user_type = userdetail.utype;
		console.log(userdetail)
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.getMerchantList();
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				this.showSelectMerchant =true;
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectWarehouse = true;
				this.showSelectMerchant =true;
				//this.getWarehouseList();
				this.getMerchantList();
				if(userdetail.merchantid){
				this.mid=userdetail.merchantid.toString()
				this.merchant=this.mid

				this.showSelectMerchant =false;
				}
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant =true;
				//this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
		this.getRecordLimit()
	},
	methods: {
		showViewForm(data) {
			this.selectedRow = data
			this.showeye = false;
		},
		callParent1() {

			this.showeye=true;
		},
		reset(){
			this.item={}
		},
		onSelect(item){

			this.item=item
			this.merchant=item.value
		},
		encryptData(encData) {
			return this.encryptor.encrypt(encData);
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getPurchaseOrderForXls(3)
		},
		//open new form(popup)
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter = {}) {

			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
				csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'
			//Fields
			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function(item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''; // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilter.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
							else
								csvData += escapedCSV + ',';
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		},

		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}

		// },

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client) {

		// 		this.clientid = this.client;
		// 		this.merchant = '';
		// 		this.getMerchantList();
		// 		this.item={}
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			// if (this.warehouseid && this.clientid) {
		// 			//  this.getPurchaseOrder();
		// 		}
		// 	}
		// 	this.totalrows = 0;
		// 	this.listPurchaseOrderData = [];
		// 	this.pageno = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.totalrows = 0;
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getPurchaseOrder();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },


		getMerchantList() {
			this.listMerchantData1=[]
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
                        var merchantlistArray=[];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
					   result.data.forEach(function(item){
						   merchantlistArray[item.merchantid]=item.merchantname;

					   })
					   this.merchantList=merchantlistArray;
					   this.listMerchantData.forEach(ele=>{
						this.listMerchantData1.push({
							"value":ele.merchantid,
							"text":ele.merchantname
						})
					   })

					}

				}, error => {
					console.error(error)
				})
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRecordLimit',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		getPurchaseOrder(csvCheck = 0) {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			if (window.localStorage.getItem('selectedClient') === 'undefined') {
				this.$alertify.error('Please select client')
				this.pageno = this.pageCount = 0;
				this.listPurchaseOrderData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse') === 'undefined') {
				this.$alertify.error('Please select warehouse')
				this.pageNo = this.pageCount = 0;
				this.listPurchaseOrderData = [];
				return false;
			}

			var fromDateFlt = '';
			var toDateFlt = '';

			if (this.fromDateFlt != "") {
				fromDateFlt = this.dateFormat(this.fromDateFlt, 1);
			}
			if (this.toDateFlt != "") {
				toDateFlt = this.dateFormat(this.toDateFlt, 2);
			}
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			this.isLoading = true;
			this.input = ({
				clientid: this.clientid,
				warehouseid:  window.localStorage.getItem('selectedWarehouse'),
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				pono: this.ponoFlt,
				fromDateFlt: fromDateFlt,
				toDateFlt: toDateFlt,
				purchasingManager: this.purchasingManager,
				loginUserEmail: this.loginUserEmail,
				supplierFlt: this.merchant,
				csvData: csvCheck,
				postatus:this.poStatus


			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'purchaseOrderList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 1) {
						this.listPurchaseOrderDatacsv = [];
						this.show = true;
						this.download = false;
						this.csvFields = {
							'clientid': this.$t('client.clientId'),
							'countpodetails': this.$t('purchaseOrder.countPoDetails'),
							'merchantname': this.$t('common.merchantName'),
							'poqty': this.$t('purchaseOrder.poQty'),
							'povalue': this.$t('purchaseOrder.poValue'),
							'createddate': this.$t('common.createdDate'),
							'lastmodifieddate': this.$t('common.lastModifiedDate'),
							'createdby': this.$t('common.createdBy'),
							'id': this.$t('common.id'),
							'lastmodifiedby': this.$t('common.lastModifiedBy'),
							'merchantid': this.$t('purchaseOrder.merchantId'),
							'pono': this.$t('purchaseOrder.PONo'),
							'postatus': this.$t('dataUploadLogs.poStatus'),
							'status': this.$t('common.status'),
							'warehouseid': this.$t('common.warehouseID'),
							'smartpocheck': this.$t('purchaseOrder.smartPo'),
							'canceledby': this.$t('purchaseOrder.canceledBy'),
							'canceleddate': this.$t('purchaseOrder.canceledDate'),
						};
						var dateFilter = [];
						var skipFilter = ['inwardid','suppliercompanyname'];
						this.listPurchaseOrderDatacsv = result.data.data;
						this.jsonToCSV(this.$t('purchaseOrder.purchaseOrderFile'), this.listPurchaseOrderDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);
					} else {
						this.listPurchaseOrderData = result.data;
						this.listPurchaseOrderData.length = result.data.totalRows

						if (result.data.errorCode == -1) {
							this.listPurchaseOrderData = [];
							this.resultCount = 0;
						}
						else{

							this.totalrows = result.data.totalRows

							this.resultCount = result.data.totalRows;


						// this.setPageCounts(result.data.totalRows);

						if (this.totalrows > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if(this.totalrows==0)
						this.totalPage = 0
						else if (this.totalrows < 10) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalrows / 10);
													}

					}
				}
					this.isLoading = false;

				}, error => {
					console.error(error)
				})
		},
		getPurchaseOrderForXls(csvCheck = 0) {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			var fromDateFlt = '';
			var toDateFlt = '';

			if (this.fromDateFlt != "") {
				fromDateFlt = this.dateFormat(this.fromDateFlt, 1);
			}
			if (this.toDateFlt != "") {
				toDateFlt = this.dateFormat(this.toDateFlt, 2);
			}


			this.input = ({
				clientid: this.clientid,
				warehouseid:  window.localStorage.getItem('selectedWarehouse'),
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				pono: this.ponoFlt,
				fromDateFlt: fromDateFlt,
				toDateFlt: toDateFlt,
				purchasingManager: this.purchasingManager,
				loginUserEmail: this.loginUserEmail,
				supplierFlt: this.merchant,
				csvData: csvCheck,
				postatus:this.poStatus

			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'purchaseOrderList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls[this.$t('purchaseOrder.PONo')]='pono'
							this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname'
							this.csvFieldsForXls[this.$t('purchaseOrder.poQty')]='poqty'
							this.csvFieldsForXls[this.$t('purchaseOrder.countPoDetails')]='countpodetails'
							this.csvFieldsForXls[this.$t('purchaseOrder.poValue')]='povalue'
							this.csvFieldsForXls[this.$t('common.createdDate')]='createddate'
							this.csvFieldsForXls[this.$t('common.lastModifiedDate')]='lastmodifieddate'
							this.csvFieldsForXls[this.$t('common.createdBy')]='createdby'
							this.csvFieldsForXls[this.$t('common.id')]='id'
							this.csvFieldsForXls[this.$t('common.lastModifiedBy')]='lastmodifiedby'
							this.csvFieldsForXls[this.$t('purchaseOrder.merchantId')]='merchantid'
							this.csvFieldsForXls[this.$t('dataUploadLogs.poStatus')]='postatus'
							this.csvFieldsForXls[this.$t('common.status')]='status'
							this.csvFieldsForXls[this.$t('client.clientId')]='clientid'
							this.csvFieldsForXls[this.$t('common.warehouseID')]='warehouseid'
							this.csvFieldsForXls[this.$t('purchaseOrder.smartPo')]='smartpocheck'
							this.csvFieldsForXls[this.$t('purchaseOrder.canceledBy')]='canceledby'
							this.csvFieldsForXls[this.$t('purchaseOrder.canceledDate')]='canceleddate'

							this.listReportDataforxls = result.data.data;
						} else {
							if (result.data.status == true) {
								this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}


				}, error => {
					console.error(error)
				})
		},

		// Search Purchase Order
		getPurchaseOrderSerach() {
			this.currentPage = 1;
			this.getPurchaseOrder(2);
		},

		getStatusRowData(poData, actionType) {

			this.modalShow = true;
			this.actionType = actionType;
			this.id = poData.id;
			this.pono = poData.pono;
			this.status = poData.status;
			this.postatus = poData.postatus;
			switch (actionType) {
				case "status":
					this.newStatus = "Active";
					if (poData.status == "Active" || poData.status == "active") {
						this.newStatus = "Inactive";
						this.statusclass = "btn-success"
					} else if (poData.status == "Inactive" || poData.status == "inactive") {
						this.newStatus = "Active";
						this.statusclass = "btn-danger"
					}
					this.newActionMsg = this.newStatus;
					break;
				case "postatus":
					this.newPoStatus = "unlock";
					if (poData.postatus == "Unlock" || poData.postatus == "unlock") {
						this.newPoStatus = "lock";
					} else if (poData.postatus == "Lock" || poData.postatus == "lock") {
						this.newPoStatus = "unlock";
					}
					this.newActionMsg = this.newPoStatus;
					break;
			}
		},

		changeStatus() {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.input = ({
				status: this.newStatus,
				postatus: this.newPoStatus,
				id: this.id,
				pono: this.pono,
				actionType: this.actionType,
				warehouseid:  window.localStorage.getItem('selectedWarehouse'),
				lastmodifiedby: this.loginUserEmail,
				clientid: this.clientid
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'actionStatus',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.status == 200) {
						this.input = ({
							pono: this.pono,
							clientid: this.clientid
						})
						axios({
							method: 'POST',
							'url': apiUrl.api_url + 'elspo',
							'data': this.input,
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						});
						this.getPurchaseOrder(2);
						this.$alertify.success("Updated Successfully.")
					}
				}, error => {
					console.error(error);
					this.$alertify.success("Does not Updated, Try again.")
				})
		},

		//Sets total number of pages
		setPageCounts(total_rows) {
			if (total_rows <= this.pageLimit) {
				this.pageCount = 1;
			} else {
				this.pageCount = Math.ceil(total_rows / this.pageLimit);
			}
		},

		//Call page number from pagination
		getPaginationData(currentPage) {
			this.pageno = (currentPage - 1) * this.pageLimit;
			this.getPurchaseOrder();
		},
		onPageChange(page) {
			console.log(page,"======================pageno")
			this.currentPage = page;
			this.getPurchaseOrder()
		},
		resetSearchForm() {
			this.show = false;
			this.download = true;
			this.totalrows = 0;
			this.ponoFlt = "";
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.merchant = "";
			this.listPurchaseOrderData = [];
			this.pageCount = 0;
			this.item={}
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
			this.poStatus='';
		},

		getScore(val) {
			return parseFloat(val).toFixed(2);
		},

		dateFormat(date, type) {
			if (!date) return '';

			if (type == 1) {
				return moment(date).format('YYYY-MM-DD 00:00:00');
			} else {
				return moment(date).format('YYYY-MM-DD 23:59:00');
			}
		},

		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/purchaseorderlist/purchaseorderlist.component.js